export enum MatchUpStatusEnum {
  ABANDONED = 'ABANDONED',
  BYE = 'BYE',
  COMPLETED = 'COMPLETED',
  DEAD_RUBBER = 'DEAD_RUBBER',
  DEFAULTED = 'DEFAULTED',
  INCOMPLETE = 'INCOMPLETE',
  IN_PROGRESS = 'IN_PROGRESS',
  NOT_PLAYED = 'NOT_PLAYED',
  RETIRED = 'RETIRED',
  SUSPENDED = 'SUSPENDED',
  TO_BE_PLAYED = 'TO_BE_PLAYED',
  WALKOVER = 'WALKOVER',
  TBP = 'TBP'
}
